import { MergeableResourceType, ResourceMergeInput, ResourceMergePreview, ResourceMergeResult } from '@/types';

import { apiClient } from '../http';

export interface ResourceMergePreviewInput {
    resourceType: MergeableResourceType;
    sourceId: string;
    targetId: string;
}

export const resourceMergeService = {
    execute: (input: ResourceMergeInput) =>
        apiClient.post<ResourceMergeResult, ResourceMergeInput>('/api/bulk/merge', input),
    preview: (input: ResourceMergePreviewInput) =>
        apiClient.post<ResourceMergePreview, ResourceMergePreviewInput>('/api/bulk/merge/preview', input),
};
